/** @module                 React */

import { useState }         from "react";

/** @module                 Router */

import { useNavigate }      from "react-router-dom";

/** @module                 Apollo */

import { useMutation }      from "@apollo/client";

import { DELETE_POST }      from "../../Mutations/Posts";

const 

/** 
 * 
 * @returns useDeletePost hook for deleting existing manager
 * 
 */

useDeletePost = () => { const 

    /** @hooks */

    navigate                    = useNavigate (),

    [ loading,  setLoading  ]   = useState ( false ),

    [ errors,   setErrors   ]   = useState ( false ),

    /** @mutations */

    [ DeletePost ] = useMutation ( DELETE_POST, {

        /** @event onComplete */

        onCompleted ( data ) {

            setLoading ( false );

            return navigate ( `/app/content/posts` );

        },

        /** @event onError */

        onError ( err ) { setLoading ( false ); setErrors ( true ); }

    } ),

    /** 
     * 
     * @param { Number } id
     * 
     * @returns delete post action
     * 
     */

    deletePost = ( id ) => {

        /** @validation */

        setErrors ( false ); setLoading ( true );

        if ( ! id ) {

            setErrors   ( true  );

            setLoading  ( false );

            return;

        };

        /** @mutation */

        DeletePost ( { variables: { id } } );

    }

    /** @returns */

    return { deletePost, loading, errors }

}

/** @exports useDeletePost */

export default useDeletePost;